/* eslint-disable */

import { ID3Tag } from "@/types/ID3Tag";
import { APILocation } from "@/types/APILocation";
import { State } from "@/types/State";
import { Video } from "@/types/Video";
import _Vue from "vue"
import { Store } from "vuex";

class PeachPlugin {
  public install(Vue: typeof _Vue, store: Store<State>) {

    (function (j, c) {
        const s = function (o) {
          const t = document.createElement('script');
          for (const p in o) {t[p] = o[p];}
          return t;
        };
        const p = s({src: j, defer: true, async: true, onload: c});
        const i = document.getElementsByTagName('script')[0];
        // @ts-ignore
        i.parentNode.insertBefore(p, i);
      })('//peach-static.ebu.io/peach-collector.min.js', PeachCollectorLoaded);


      const endpoints =[
        {
          sitekey:'ietg400000000041',
          payload_func: function(payload){

            const locationResponse: APILocation | undefined = store.state.apiLocation


            payload.client.country_code=locationResponse?.countryCode;
            payload.client.city_name=locationResponse?.city;

            const user = store.state.user
            if (user && user.id && user.id > 0) {
              payload.user_id=user.id.toString();
              payload.client.user_logged_in = true;
            } else {
              payload.client.user_logged_in = false;
            }
            return payload;}
          }
        ]


      function PeachCollectorLoaded() {
        try {
        // @ts-ignore
        const _pc = window._pc = new PeachCollector(window);
        _pc.init(endpoints, 'SmartTV')
          .enableTracking()
          .sendPageViewEvent()
          .enableTracking();  
        } catch (err) {
          console.error(err)
        }
      }


    Vue.prototype.$peach = this

  }


  public trackVideo(video: Video, player: HTMLVideoElement) {

    try {
      // console.log("Starting video tracking " + video.reference_id)

      const peach = window._pc
      if (!peach) {
        // console.log("Peach not loaded")
        return
      }
      const type = "video"  
      const source = "vod" 

      const component = peach.EventContextComponent("player", "SmartTV", "1.3.0");

      const context = peach.mediaContext(video.reference_id, type, "TG4", window.location.href, source, component);

      const extended_event_config = { 
        media_heartbeat: {heartbeat_interval: 30},
        media_seek: true,
        media_play: true,
        media_pause: true,
        media_stop: true
      };

      const props = peach.EventProps().setVideoModeFullScreen();

      const available = video.custom_fields.geo_restrict === "N" ? "Worldwide" : "Ireland Only"

      const metadata =  
      {
        "type": "video",
        "format": "ondemand",
        "episode_id": video.custom_fields.p_prodcode,
        "show_id": video.custom_fields.s_prodcode,
        "duration": video.duration / 1000,
        "show title": video.custom_fields.seriestitle,
        "genre": video.custom_fields.category_c,
        "available": available,
        "episode title": video.custom_fields.title,
        "episode date": video.custom_fields.date,
        "live event": "False",
      };


      peach.trackMediaEvents(player, video.reference_id, context, props, metadata, extended_event_config);

      // console.log("Peach setup complete")
    } catch (err) {
      // console.log(err);
      console.error(err)
    }
  }

  public trackID3Tag(id3Tag: ID3Tag, player: HTMLVideoElement) {

    try {
     
      const peach = window._pc
      if (!peach) {
        // console.log("Peach not loaded")
        return
      }
      const show_ioi = id3Tag.ioi;
      const show_ww = id3Tag.ww;
      let show_available = ''
      if ((show_ioi == 'True') && (show_ww == 'False')) {
          show_available = "Ireland Only";
      } else if ((show_ioi == 'True') && (show_ww == 'True')) {
          show_available = "Worldwide";
      }

      const show_id = id3Tag.scode;
      const show_title = id3Tag.series_title;
      const show_genre = id3Tag.prog_genre;
      const episode_id = id3Tag.pcode;
      const episode_title = id3Tag.title;
      const episode_date = id3Tag.start_date_time;
      const live_event = "True";

      const frameDuration = parseFloat(id3Tag.full_dur_frames || "0")
      const duration =  Math.round(frameDuration / 25)

      const extended_event_config = {
          media_heartbeat: {heartbeat_interval: 30}, // event_name, event_configuration or true
          media_seek: true,
          media_play: true,
          media_pause: true,
          media_stop: true
      };

      const props = peach.EventProps().setVideoModeFullScreen();

      const component = peach.EventContextComponent('player', 'SmartTV', "1.3.0");
      const context = peach.mediaContext(id3Tag.material_id, 'video', null, document.referrer, "live", component);
      const metadata = peach.EventMetadata('video', 'live', episode_id, show_id, duration);

      metadata.setCustomField('show title', show_title);
      metadata.setCustomField('genre', show_genre);
      metadata.setCustomField('available', show_available);
      metadata.setCustomField('episode title', episode_title);
      metadata.setCustomField('episode date', episode_date);
      metadata.setCustomField('live event', live_event);
      context.setCustomField('referrer', 'TG4');
      context.setCustomField('source', 'TG4 Live');

      // console.log("EP Title: ", episode_title)

      peach.trackMediaEvents(player, id3Tag.material_id, context, props, metadata, extended_event_config);
      
      // console.log("Peach setup complete")
    } catch (err) {
      // console.log(err);
      console.error(err)
    }
  }


}

export default new PeachPlugin() ;